<div class="sub-section-wrapper">
  <span class="section-sub-title">Exact Location <span class="mandatory" *ngIf="IsRequired===true">*</span> </span>
  
  <div style="display: flex;">
    <!-- <input type="text" maxLength="500" [(ngModel)]="Location" (keyup)="ngOnChanges()" style="width: 93%;"
      class="form-control" id="exact-location" placeholder="Exact Location" [disabled]="Disabled"> -->
      <input ngx-google-places-autocomplete [(ngModel)]="Location" class="form-control" placeholder="Exact Location" #locationInput (blur)="!locationInput.place && Location = ''" (onAddressChange)="addressChange($event)" />
      <button (click)="Disabled ? $event.preventDefault : getLocation()"
        [ngClass]="Disabled ? 'disabled' : 'cursor-pointer'" pTooltip="Get your location"
        class="btn btn-primary primary-btn">
        <em class="fa fa-map-marker"></em>
      </button>
  </div>
</div>
<p-dialog [(visible)]="SelectLocationDialog" (onHide)="closePopUp()" header="Select Location" [modal]="true" [style]="{width:'500px'}">
  <div class="p-field">
    <agm-map [latitude]="latitude" [longitude]="longitude" (mapClick)="onChoseLocation($event)">
      <agm-marker
       [latitude]="latitude" 
       [longitude]="longitude"
       *ngIf="locationChosen==true"
       ></agm-marker>   
  </agm-map>
  </div>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Select" (click)="SelectLocation()"
      [disabled]="locationChosen== false" icon="pi pi-check" class="p-button-text"></button>
  </ng-template>
</p-dialog>
